import { render } from "./ContentsRightAttachmentDownloadButton.vue?vue&type=template&id=ce4ac660&ts=true"
import script from "./ContentsRightAttachmentDownloadButton.vue?vue&type=script&lang=ts"
export * from "./ContentsRightAttachmentDownloadButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__